import React, { memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { CommonData } from '@alycecom/modules';

import { IVerifiedAddress } from '../../types/Shipping.types';
import { getCountryById } from '../../../../store/countries/countries.selectors';

export interface IVerifiedAddressProps {
  address: IVerifiedAddress;
}

const VerifiedAddress = ({ address }: IVerifiedAddressProps): JSX.Element => {
  const { addressLines, stateCode, stateName, city, zipcode, countryId } = address;
  const country = useSelector(useMemo(() => getCountryById(countryId || CommonData.COUNTRIES.US.id), [countryId]));

  return (
    <Box>
      {addressLines.map(line => (
        <Typography key={line} className="Body-Regular-Left-Static">
          {line}
        </Typography>
      ))}
      <Typography className="Body-Regular-Left-Static">
        {city}, {stateCode || stateName} {zipcode}
      </Typography>
      <Typography className="Body-Regular-Left-Static">{country?.name}</Typography>
    </Box>
  );
};

export default memo<IVerifiedAddressProps>(VerifiedAddress);
